module.exports = __webpack_public_path__ + "img/header-shape-2.a3e96bbd.svg";